export default __webpack_public_path__ + "static/media/57.b7e0c0c6.png";